<script>
import { Carousel, Navigation, Slide } from "vue3-carousel";
import Our_Branches from "@/assets/json/our-branches.json";
import "vue3-carousel/dist/carousel.css";
export default {
  data() {
    return {
      Our_Branches: Our_Branches,
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
        loop: true,
        margin: 24,
      },

      breakpoints: {
        575: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        // 700px and up
        767: {
          itemsToShow: 2,
          snapAlign: "center",
        },
        // 991px and up
        991: {
          itemsToShow: 3,
          snapAlign: "center",
        },
        // 1024 and up
        1024: {
          itemsToShow: 4,
          snapAlign: "start",
        },
      },
    };
  },
  components: {
    Carousel,
    Slide,
    Navigation,
  },
};
</script>
<template>
  <div class="accordion-item mb-3">
    <div class="accordion-header" id="accordion-headingSix">
      <div
        class="accordion-button p-0"
        data-bs-toggle="collapse"
        data-bs-target="#accordion-collapseSix"
        aria-expanded="true"
        aria-controls="accordion-collapseSix"
        role="button"
      >
        Our Branches
      </div>
    </div>
    <div
      id="accordion-collapseSix"
      class="accordion-collapse collapse show"
      aria-labelledby="accordion-headingSix"
    >
      <div class="accordion-body p-0 mt-3 pb-1">
        <div class="our-branches-slider owl-carousel custom-owl-dot">
          <Carousel :wrap-around="true" :settings="settings" :breakpoints="breakpoints">
            <Slide v-for="item in Our_Branches" :key="item.id">
              <div class="card shadow-none rounded">
                <div class="card-body text-center px-2">
                  <span class="d-block mb-2"
                    ><img
                      :src="require(`@/assets/img/icons/${item.Image}`)"
                      class="w-auto m-auto"
                      alt="Img"
                  /></span>
                  <h6 class="mb-2">{{ item.Name }}</h6>
                  <p class="d-flex align-items-center justify-content-center fs-14">
                    <i class="ti ti-map-pin me-1"></i>{{ item.Location }}
                  </p>
                </div>
              </div>
            </Slide>
            <template #addons>
              <Navigation />
            </template>
          </Carousel>
        </div>
      </div>
    </div>
  </div>
</template>
